<template>
    <div class="sdr-box">
        <h5 class="box-title">{{ aboutsundair[getCurrentLocale] }}</h5>
        <p v-html="aboutsundairtext[getCurrentLocale]"></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            aboutsundair: {
                en: 'About European Air Charter',
                de: 'Über European Air Charter',
            },
            aboutsundairtext: {
                en: '<strong>European Air Charter</strong>  is a Bulgarian airline founded in 2000. Its core business is operating charter flights for well-known European tour operators. European Air Charter flies primarily to the resorts of Varna and Burgas, both located on the Black Sea. The fleet includes 10 Airbus A320 aircraft.',
                de: '<strong>European Air Charter</strong>  ist eine bulgarische Fluggesellschaft, die 2000 gegründet wurde. Das Kerngeschäft besteht in der Durchführung von Charterflügen für bekannte europäische Reiseveranstalter. European Air Charter fliegt vorrangig die Urlaubsorte Varna und Burgas an, die beide am Schwarzen Meer liegen. Die Flotte umfasst 10 Maschinen vom Typ Airbus A320. ',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {
        ...mapGetters(['getCurrentLocale']),
    }, // eof computed{}
    /* <<< ****************************************************************/
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/AboutSundairBox.vue